<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.89" height="19.967" viewBox="0 0 21.89 19.967">
    <g transform="translate(-1101.924 -580.267)">
      <path
        d="M1116.966,600.234c-.427,0-.811-.007-1.194-.03-1.473-.087-2.452-.47-4.36-2.507-1.1-1.171-2.487-2.547-3.6-3.651-.8-.788-1.426-1.411-1.669-1.685a1.949,1.949,0,0,1,.082-2.745,1.955,1.955,0,0,1,.408-.3c.646-.371,6.059-5.537,9.316-8.7l.358-.347,4.842,4.948-.425.346a43.937,43.937,0,0,0-3.388,3.064,2.758,2.758,0,0,0-.439,1.921,1.229,1.229,0,0,0,.372.836,5.316,5.316,0,0,0,3.758,1.167,2.493,2.493,0,0,1,1.871.757c1.015,1.081.939,2.959.9,3.861l-.007.2c0,.113,0,.237.011.365a2.257,2.257,0,0,1-.456,1.791,3,3,0,0,1-2.283.68c-1.178-.005-2.1.006-2.854.017C1117.743,600.229,1117.338,600.234,1116.966,600.234Zm-.681-18.555c-1.761,1.707-8.269,8-9.168,8.512a.951.951,0,0,0-.242,1.494c.233.261.883.905,1.636,1.65,1.124,1.111,2.521,2.494,3.632,3.679,1.825,1.949,2.611,2.129,3.688,2.192.679.039,1.386.029,2.362.016.764-.012,1.688-.022,2.873-.017a2.406,2.406,0,0,0,1.554-.37c.208-.217.206-.556.181-1.049-.008-.155-.015-.3-.012-.443l.008-.216c.029-.707.1-2.361-.632-3.137a1.487,1.487,0,0,0-1.112-.443,6.211,6.211,0,0,1-4.389-1.366,2.136,2.136,0,0,1-.763-1.509,3.709,3.709,0,0,1,.7-2.724q1.491-1.5,3.069-2.814Z"
      />
      <path
        d="M1116.729,589.178c-.111-.013-2.731-.342-3.1-2.072a3.921,3.921,0,0,0-1.5-2.045l.574-.819a4.947,4.947,0,0,1,1.892,2.616c.193.9,1.691,1.259,2.253,1.328Z"
      />
      <path
        d="M1117.734,597.532a17.179,17.179,0,0,1-2.555-.1c-.414-.136-3.019-2.8-7.741-7.923l.734-.678c2.574,2.791,6.855,7.345,7.384,7.679.335.053,4.066.022,7.361-.054l.023,1C1121.448,597.492,1119.371,597.532,1117.734,597.532Z"
      />
      <rect
        width="1.528"
        height="1"
        transform="translate(1115.36 592.618) rotate(-45.317)"
      />
      <rect
        width="1"
        height="1.7"
        transform="translate(1118.391 592.97)"
      />
      <rect
        width="3.185"
        height="1"
        transform="translate(1101.924 593.837)"
      />
      <rect
        width="5.744"
        height="1"
        transform="translate(1101.924 596.531)"
      />
      <rect
        width="8.282"
        height="1"
        transform="translate(1101.924 598.969)"
      />
    </g>
  </svg>
</template>
